import { resource } from '@util/resource';
import { Observable } from 'rxjs';
import { Injectable} from '@angular/core';
import { NotificationDWS } from '@interfaces/dws/notification-dws';
import { AdminNotificationDetail, AdminNotificationPage, AdminNotificationStats } from '@interfaces/dws/admin-notification';


@Injectable({
  providedIn: 'root'
})
export class NotificationsAdminService {
  constructor() {}

  pushNotification(notification: NotificationDWS): Observable<unknown> {
    return resource('crm://admin/notifications/push')
        .headers({ 'x-admin-authorization': '1' })
        .post(notification);
  }

  listNotifications(page: number = 0, count: number = 50, search?: string): Observable<AdminNotificationPage> {
    return resource('crm://admin/notifications')
      .headers({ 'x-admin-authorization': '1' })
      .params({ page, count, search })
      .get<AdminNotificationPage>();
  }

  getNotification(campaignId: string): Observable<AdminNotificationDetail> {
    return resource('crm://admin/notifications/campaignId')
      .headers({ 'x-admin-authorization': '1' })
      .params({ campaignId })
      .get<AdminNotificationDetail>();
  }

  updateNotification(campaignId: string, notification: NotificationDWS): Observable<unknown> {
    return resource('crm://admin/notifications/campaignId')
        .headers({ 'x-admin-authorization': '1' })
        .params({ campaignId })
        .put(notification);
  }

  setPublicationPaused(campaignId: string, paused: boolean): Observable<unknown> {
    return resource('crm://admin/notifications/campaignId/publication-paused')
        .headers({ 'x-admin-authorization': '1' })
        .params({ campaignId })
        .put({ paused });
  }

  deleteNotification(campaignId: string): Observable<void> {
    return resource('crm://admin/notifications/campaignId')
      .headers({ 'x-admin-authorization': '1' })
      .params({ campaignId })
      .delete();
  }

  getNotificationStats(campaignId: string): Observable<AdminNotificationStats> {
    return resource('crm://admin/notifications/campaignId/stats')
      .headers({ 'x-admin-authorization': '1' })
      .params({ campaignId })
      .get<AdminNotificationStats>();
  }
}
